import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { authFB,storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    SUPPLIER_COM_SUPPLIER,
    SUPPLIER_COM_EMAIL,
    SUPPLIER_COM_PO,
    SUPPLIER_COM_CATEGORY,
    SUPPLIER_COMMUNICATION_LIST,
    SUPPLIER_COMMUNICATION_ADD,
    SUPPLIER_COMMUNICATION_EDIT,
    SUPPLIER_COMMUNICATION_UPLOAD_SET
} from "../../actions";

import {
    SupplierComSupplierSuccess,
    SupplierComSupplierError,
    SupplierComEmailSuccess,
    SupplierComEmailError,
    SupplierComPOSuccess,
    SupplierComPOError,
    SupplierComCategorySuccess,
    SupplierComCategoryError,
    SupplierCommunicationListSuccess,
    SupplierCommunicationListError,
    SupplierCommunicationAddSuccess,
    SupplierCommunicationAddError,
    SupplierCommunicationEditSuccess,
    SupplierCommunicationEditError,
    SupplierCommunicationUploadSetSuccess,
    SupplierCommunicationUploadSetError
} from '../../actions';

export function* watchSupplierComSupplier() {
    yield takeEvery(SUPPLIER_COM_SUPPLIER, onSupplierComSupplier);
}

export function* watchSupplierComEmail() {
    yield takeEvery(SUPPLIER_COM_EMAIL, onSupplierComEmail);
}

export function* watchSupplierComPO() {
    yield takeEvery(SUPPLIER_COM_PO, onSupplierComPO);
}

export function* watchSupplierComCategory() {
    yield takeEvery(SUPPLIER_COM_CATEGORY, onSupplierComCategory);
}

export function* watchSupplierCommunicationList() {
    yield takeEvery(SUPPLIER_COMMUNICATION_LIST, onSupplierCommunicationList);
}

export function* watchSupplierCommunicationAdd() {
    yield takeEvery(SUPPLIER_COMMUNICATION_ADD, onSupplierCommunicationAdd);
}

export function* watchSupplierCommunicationEdit() {
    yield takeEvery(SUPPLIER_COMMUNICATION_EDIT, onSupplierCommunicationEdit);
}

export function* watchSupplierCommunicationUploadSet() {
    yield takeEvery(SUPPLIER_COMMUNICATION_UPLOAD_SET, onSupplierCommunicationUploadSet);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onSupplierComSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunication/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSupplierComEmailAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunication/supplieremail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSupplierComPOAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunication/polist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSupplierComCategoryAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunication/category', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


const onSupplierCommunicationListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunication/communicationlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onSupplierCommunicationAddAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunication/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

const onSupplierCommunicationEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunication/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

const onSupplierCommunicationUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/communicationdocs/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'answerforms/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

function* onSupplierComSupplier(data) {
    try {
        const response = yield call(onSupplierComSupplierAsync, data.payload);
        yield put(SupplierComSupplierSuccess(response.data));
    } catch (error) {
        yield put(SupplierComSupplierError(error));
    }
}

function* onSupplierComEmail(data) {
    try {
        const response = yield call(onSupplierComEmailAsync, data.payload);
        yield put(SupplierComEmailSuccess(response.data));
    } catch (error) {
        yield put(SupplierComEmailError(error));
    }
}

function* onSupplierComPO(data) {
    try {
        const response = yield call(onSupplierComPOAsync, data.payload);
        yield put(SupplierComPOSuccess(response.data));
    } catch (error) {
        yield put(SupplierComPOError(error));
    }
}

function* onSupplierComCategory(data) {
    try {
        const response = yield call(onSupplierComCategoryAsync, data.payload);
        yield put(SupplierComCategorySuccess(response.data));
    } catch (error) {
        yield put(SupplierComCategoryError(error));
    }
}

function* onSupplierCommunicationList(data) {
    try {
        const response = yield call(onSupplierCommunicationListAsync, data.payload);
        yield put(SupplierCommunicationListSuccess(response.data));
    } catch (error) {
        yield put(SupplierCommunicationListError(error));
    }
}

function* onSupplierCommunicationAdd(data) {
    try {
        const response = yield call(onSupplierCommunicationAddAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SupplierCommunicationAddSuccess(response.data));
    } catch (error) {
        yield put(SupplierCommunicationAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onSupplierCommunicationEdit(data) {
    try {
        const response = yield call(onSupplierCommunicationEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SupplierCommunicationEditSuccess(response.data));
    } catch (error) {
        yield put(SupplierCommunicationEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}


function* onSupplierCommunicationUploadSet({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onSupplierCommunicationUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(SupplierCommunicationUploadSetSuccess(response));

        }
        else {
            yield put(SupplierCommunicationUploadSetError(response));
        }
    } catch (error) {
        yield put(SupplierCommunicationUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchSupplierComSupplier), 
        fork(watchSupplierComEmail),
        fork(watchSupplierComPO),
        fork(watchSupplierComCategory),
        fork(watchSupplierCommunicationList),
        fork(watchSupplierCommunicationAdd),
        fork(watchSupplierCommunicationEdit),
        fork(watchSupplierCommunicationUploadSet)
    ]);
}